import { __decorate, __metadata } from "tslib";
import { ProductFeatureType, ProductId } from '@cbbt/itf-onboarding-common';
import { BaseMessage, Field } from '@cbbt/lib-interface';
export class ProductFeatureDetails extends BaseMessage {
    individualId;
    productId;
    productFeatureType;
}
__decorate([
    Field.string({
        description: 'Individual Id of the user',
        required: true,
        format: 'uuid',
    }),
    __metadata("design:type", String)
], ProductFeatureDetails.prototype, "individualId", void 0);
__decorate([
    Field.enum({
        enum: ProductId,
        description: 'Product id',
        required: true,
    }),
    __metadata("design:type", String)
], ProductFeatureDetails.prototype, "productId", void 0);
__decorate([
    Field.enum({
        enum: ProductFeatureType,
        description: 'Type of product feature',
        required: true,
    }),
    __metadata("design:type", String)
], ProductFeatureDetails.prototype, "productFeatureType", void 0);
//# sourceMappingURL=ProductFeatureDetails.js.map